import { Moment } from "moment";
import { map } from "lodash";
import moment from "moment";
import PosicaoAtivoInternacional from "./posicaoAtivoInternacional";

export default class PosicaoInternacional implements IPosicaoInternacional {
  public data!: Moment;
  public posicoes!: PosicaoAtivoInternacional[];

  constructor(param: IPosicaoInternacional) {
    Object.assign(this, param);
  }

  static parse(json: any): PosicaoInternacional {
    return new PosicaoInternacional({
      ...json,
      data: moment(json.data),
      posicoes: map(json.posicoes, (p) => new PosicaoAtivoInternacional(p)),
    });
  }

  toJSON(): IPosicaoInternacionalJson {
    return {
      data: this.data.toISOString(),
      posicoes: this.posicoes.map((p) => ({
        codigoAtivo: p.codigoAtivo,
        quantidade: p.quantidade,
        custoMedioOriginal: p.custoMedioOriginal,
        custoMedioBRL: p.custoMedioBRL,
        moeda: p.moeda,
        valorTotalOriginal: p.valorTotalOriginal,
        valorTotalBRL: p.valorTotalBRL,
      })),
    };
  }
}

export interface IPosicaoInternacionalJson {
  data: string;
  posicoes: {
    codigoAtivo: string;
    quantidade: number;
    custoMedioOriginal: number;
    custoMedioBRL: number;
    moeda: string;
    valorTotalOriginal: number;
    valorTotalBRL: number;
  }[];
}

interface IPosicaoInternacional {
  data: Moment;
  posicoes: PosicaoAtivoInternacional[];
}